/**
 * Converts a string to snake_case
 * @param str - The string to convert
 * @returns The string in snake_case format
 * @example
 * toSnakeCase('My View Name') // 'my_view_name'
 * toSnakeCase('MyViewName') // 'my_view_name'
 * toSnakeCase('my-view-name') // 'my_view_name'
 */
export const toSnakeCase = (str) => {
    return str
        .trim()
        .replace(/([a-z])([A-Z])/g, '$1_$2') // Insert underscore between lowercase and uppercase letters
        .replace(/[\s-]+/g, '_') // Replace spaces and hyphens with underscores
        .replace(/[^a-zA-Z0-9_]/g, '') // Remove any non-alphanumeric characters except underscores
        .toLowerCase(); // Convert to lowercase
};
